import * as html from 'smg/html';
import Offcanvas from 'smg/offcanvas';
import QueryString from 'smg/querystring';
import * as template from 'smg/template';
const activeFiltersBar = document.querySelector<HTMLElement>('#active-filters');
const activeFiltersContainer = activeFiltersBar?.querySelector<HTMLElement>('#active-filters-container');
const filtersPanel = document.querySelector<HTMLElement>('#filters');
const filterToggleBtn = document.querySelectorAll<HTMLButtonElement>('.filter-toggle');
const filterMobileToggleBtn = document.querySelectorAll<HTMLButtonElement>('.filter-toggle-mobile');
const filterKeyword = filtersPanel?.querySelector<HTMLInputElement>('#filter-keyword');

export declare interface FilterCategoryState {
    name: string;
    options: string[];
}

export declare interface FilterEventDetail {
    filters: FilterCategoryState[];
}

if (activeFiltersBar && activeFiltersContainer && filtersPanel && filterToggleBtn && filterMobileToggleBtn && filterKeyword) {
    let filterState = '';
    let filters: FilterCategoryState[] = [];

    const sendFilterUpdateEvent = () => {
        const event = new CustomEvent<FilterEventDetail>('filterUpdate', {
            detail: {
                filters: filters,
            },
        });
        document.dispatchEvent(event);
    };

    const getFilterState = () => {
        let output = '';
        const activeFilterElements = filtersPanel?.querySelectorAll<HTMLInputElement>(':checked');
        activeFilterElements?.forEach(filter => {
            output += filter.name + ':' + filter.value + ',';
        });
        return output;
    };

    filterToggleBtn.forEach($ => $.addEventListener('click', () => {
        filtersPanel?.classList.toggle('d-lg-none');
        if (filtersPanel?.classList.contains('d-lg-none')) {
            filtersPanel?.classList.remove('d-lg-block');
            $.innerHTML = 'Show Filters <span class="material-symbols-outlined">tune</span>';

            window.dispatchEvent(new Event('.filters-hidden'));
        } else {
            filtersPanel?.classList.add('d-lg-block');
            $.innerHTML = 'Hide Filters <span class="material-symbols-outlined">tune</span>';

            window.dispatchEvent(new Event('.filters-shown'));
        }
    }));

    filterMobileToggleBtn.forEach($ => $.addEventListener('click', () => {
        let placement: 'bottom' | 'start' = 'bottom';
        if (window.innerWidth > 576) {
            placement = 'start';
        }
        let updateScrollHeight = () => undefined;
        const oc = new Offcanvas({
            title: 'Filters',
            placement: placement,
            confirmText: 'Apply Filters',
            body: template.Clone('#filters-offcanvas-mobile-body'),
            cancelButton: false,
            appendClassBySelector: {
                '.offcanvas-footer': 'd-flex justify-content-center p-4 pb-8 p-sm-8',
                '.offcanvas-body': 'py-0 px-4 px-sm-8 position-relative',
                '#offcanvas-confirm-btn': 'w-100 w-sm-auto',
            },
            onSubmit: () => {
                const ocFilterKeyword = oc.$.querySelector<HTMLInputElement>('#filter-keyword-mobile');
                if (ocFilterKeyword && filterKeyword) {
                    filterKeyword.value = ocFilterKeyword.value;
                }
                filtersPanel?.querySelectorAll<HTMLInputElement>('input[type="checkbox"]').forEach($filter => {
                    $filter.checked = false;
                });
                oc.$?.querySelectorAll<HTMLInputElement>(':checked').forEach($filter => {
                    const mainFilter = filtersPanel?.querySelector<HTMLInputElement>(`input[name="${CSS.escape($filter.name)}"][value="${CSS.escape($filter.value)}"]`);
                    if (mainFilter) {
                        mainFilter.checked = true;
                    }
                });
                updateActiveFilters();
                updateScrollHeight = () => undefined;
            },
        });
        oc.$.classList.add('filter-offcanvas');
        window.onresize = () => {
            if (window.innerWidth > 576) {
                oc.$.classList.add('offcanvas-start');
                oc.$.classList.remove('offcanvas-bottom');
            } else {
                oc.$.classList.add('offcanvas-bottom');
                oc.$.classList.remove('offcanvas-start');
            }
        };
        const title = oc.$.querySelector('.offcanvas-title');
        if (title) {
            title.outerHTML = '<h3 class="text-primary d-flex align-items-center gap-2 m-0"><span class="material-symbols-outlined">tune</span><span>Filters</span></h3>';
        }
        oc.$.querySelector('.offcanvas-footer')?.classList.remove('justify-content-end');

        // Match filters from main panel to offcanvas
        const ocFilterKeyword = oc.$.querySelector<HTMLInputElement>('#filter-keyword');
        if (ocFilterKeyword && filterKeyword) {
            ocFilterKeyword.value = filterKeyword.value;
        }

        filtersPanel?.querySelectorAll<HTMLInputElement>(':checked').forEach($filter => {
            const ocFilter = oc.$.querySelector<HTMLInputElement>(`input[name="${CSS.escape($filter.name)}"][value="${CSS.escape($filter.value)}"]`);
            if (ocFilter) {
                ocFilter.checked = true;
            }
        });

        updateScrollHeight = () => {
            const ocBody = oc.$.querySelector<HTMLElement>('.offcanvas-body');
            const ocFooter = oc.$.querySelector<HTMLElement>('.offcanvas-footer');
            if (ocBody && ocFooter) {
                const scrollBottom = ocBody.scrollHeight - ocBody.clientHeight - ocBody.scrollTop;
                ocFooter.style.setProperty('--scroll', String(scrollBottom));
            }
            setTimeout(updateScrollHeight, 50);
        };
        updateScrollHeight();
    }));

    filtersPanel?.addEventListener('click', () => {
        const newSelectedFilters = getFilterState();

        if (newSelectedFilters === filterState) {
            return;
        }
        filterState = newSelectedFilters;
        updateActiveFilters();
    });

    const updateActiveFilters = () => {
        const activeFilterOptions = filtersPanel?.querySelectorAll<HTMLInputElement>(':checked');
        if (activeFiltersContainer) {
            activeFiltersContainer.innerHTML = '';
            if (filterKeyword?.value !== '') {
                activeFiltersContainer?.appendChild(html.FromString(
                    `<div class="badge rounded-pill active-filter-badge text-bg-white text-primary fw-medium d-flex align-items-center text-nowrap">
                        Keyword: ${html.Escape(filterKeyword?.value ?? '')}
                        <button class="btn p-0 material-symbols-rounded remove-keyword fs-4 ms-2">close</button>
                    </div>`));
            }
            filters = [];
            activeFilterOptions?.forEach($filterOption => {
                const filterName = $filterOption.name;
                const filterValue = $filterOption.value;
                const badgeName = $filterOption.getAttribute('data-badge-name') || filterValue;
                const existingFilter = filters.find(f => f.name === filterName);
                if (existingFilter) {
                    existingFilter.options.push(filterValue);
                } else {
                    filters.push({
                        name: filterName,
                        options: [filterValue],
                    });
                }
                activeFiltersContainer?.appendChild(html.FromString(
                    `<div class="badge rounded-pill active-filter-badge text-bg-white text-primary fw-medium d-flex align-items-center text-nowrap">
                        ${html.Escape($filterOption.name === 'is3d' ? `3D: ${badgeName}` : badgeName)}
                        <button class="btn p-0 material-symbols-rounded remove-filter fs-4 ms-2" data-filter-select="${$filterOption.id}">close</button>
                    </div>`));
            });
            activeFiltersContainer.querySelectorAll('.remove-filter').forEach($el => {
                $el.addEventListener('click', e => {
                    e.preventDefault();
                    const filterSelect = $el.getAttribute('data-filter-select');
                    if (!filterSelect) {
                        return;
                    }
                    const filterOption = document.querySelector<HTMLInputElement>('#' + filterSelect);
                    if (filterOption) {
                        filterOption.checked = false;
                        $el.parentElement?.remove();
                        updateActiveFilters();
                        sendFilterUpdateEvent();
                    }
                    if (!activeFiltersContainer?.firstElementChild) {
                        const urlFilters = QueryString().get('filters');
                        if (urlFilters) {
                            QueryString().delete('filters');
                        }
                    }
                });
            });
            activeFiltersContainer.querySelector('.remove-keyword')?.addEventListener('click', e => {
                e.preventDefault();
                if (filterKeyword) {
                    filterKeyword.value = '';
                }
                updateActiveFilters();
                sendFilterUpdateEvent();
            });
        }
        sendFilterUpdateEvent();
        document.getElementById('main')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    activeFiltersBar?.querySelectorAll<HTMLAnchorElement>('.clear-active-filters').forEach($el => {
        $el?.addEventListener('click', e => {
            e.preventDefault();
            const urlFilters = QueryString().get('filters');
            if (urlFilters) {
                QueryString().delete('filters');
            }
            if (filtersPanel && activeFiltersContainer) {
                const activeFilterOptions = filtersPanel.querySelectorAll<HTMLInputElement>(':checked');
                activeFilterOptions.forEach($el => {
                    $el.checked = false;
                });
                activeFiltersContainer.innerHTML = '';
                updateActiveFilters();
                sendFilterUpdateEvent();
                document.getElementById('main')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        });
    });

    filterKeyword?.addEventListener('input', () => {
        updateActiveFilters();
        sendFilterUpdateEvent();
    });

    // scroll shadows
    const filterScroll = () => {
        if (activeFiltersContainer) {
            const scrollLeft = activeFiltersContainer.scrollLeft;
            const scrollWidth = activeFiltersContainer.scrollWidth;
            const clientWidth = activeFiltersContainer.clientWidth;
            const scrollRight = scrollWidth - clientWidth - scrollLeft;
            activeFiltersContainer.style.setProperty('--scroll-left', String(scrollLeft));
            activeFiltersContainer.style.setProperty('--scroll-right', String(scrollRight));
        }
        setTimeout(filterScroll, 50);
    };
    filterScroll();

    updateActiveFilters();
}